import Units from "./Units";
import {formatUnitsValue, convertUnits, getStepValue} from "./unitsHelper";
/**
 * Class to handle the Units conversion
 */
export default class UnitsConversionHelper {
    /**
     * @param {number} qty - the product's quantity
     * @param {object} info - the conversions information
     */
    constructor(qty, info) {
        this.hasAlternativeUnit = info && info.hasAlternativeSaleUnit ? info.hasAlternativeSaleUnit : false;
        this.primaryUnit = info && info.primaryunit ? info.primaryunit : "un";
        this.secondaryUnit = info && info.secondaryunit ? info.secondaryunit : null;
        this.conversionRate = info && info.unitConversionRate ? info.unitConversionRate : 1;
        this.minQty = info && info.minOrderQuantity ? info.minOrderQuantity : 1;
        this.maxQty = info && info.maxNumberOfUnitsPerSale ? info.maxNumberOfUnitsPerSale : null;
        this.step = info && info.stepQuantity ? info.stepQuantity : 1;
        this.selectedUnit = "un";
        this.units = new Units(qty, this.primaryUnit);
        this.syncFlag = {};
    }

    /**
     * Returns the Units value
     */
    getValue() {
        return this.units.getValue();
    }

    /**
     * Sets the Units value
     * @param {number} val - the new units value
     */
    setValue(val) {
        this.units.setValue(val);
    }

    /**
     * Adds the conversion step to the units
     */
    addStep() {
        const newVal = (this.units.value + (this.step * this.units.multiplier)) / this.units.multiplier;
        const valueToAdd = (this.maxQty && newVal > this.maxQty) ? this.maxQty : this.step;
        const unitsToAdd = new Units(valueToAdd, this.primaryUnit);
        this.units.add(unitsToAdd);
    }

    /**
     * Subtracts the conversion step from the units
     */
    subtractStep() {
        const unitsToSubtract = new Units(this.step, this.primaryUnit);
        this.units.subtract(unitsToSubtract);
    }

    /**
     * Updates the Units value
     * @param {number} newValue - the new units value
     */
    updateValue(newValue, selectedUnit, convertValue = true) {
        let valueToUpdate = parseFloat(newValue);

        if (convertValue) {
            if (this.primaryUnit !== selectedUnit) {
                valueToUpdate = convertUnits(valueToUpdate, this.primaryUnit, this.conversionRate, this.units.multiplier);
            }

            valueToUpdate = getStepValue(valueToUpdate, this.step, this.units.multiplier);
            valueToUpdate = (this.maxQty && valueToUpdate > this.maxQty) ? this.maxQty : ((this.minQty && valueToUpdate < this.minQty) ? this.minQty : valueToUpdate);
        }

        this.setValue(valueToUpdate);
    }

    /**
     * Gets the formatted current unit
     * @return {string} - formatted current unit value
     */
    getFormattedValue() {
        return (this.selectedUnit === this.primaryUnit) ? formatUnitsValue(this.units) : formatUnitsValue(this.units, this.secondaryUnit, this.conversionRate);
    }
}
